import { useWSModal } from "@wingspanhq/fe-component-library";
import { ModalShareTaxInformationWithPayer } from "./index";

export const useModalShareTaxInformationWithPayer = () =>
  useWSModal(ModalShareTaxInformationWithPayer, {
    size: "S",
    title: "Share Tax Information"
  });
